<template>
  <div class="topics-declaration">

    <div class="container-fluid">
      <!-- Begin page -->
      <div class="wrapper">
        <div class="content-page content-subProject">
          <div class="content">

            <div class="row">
              <div class="col-12">
                <div class="page-title-box">
                  <div class="page-title-right">
                    <Breadcrumb />
                  </div>
                  <h3 class="header-title mb-3">区级课题</h3>
                </div>
                <!-- end page-title-box -->
              </div>
            </div>

            <div class="row row-subProject pt-3">
              <div class="col-md-4 col-xl-3" v-for="item in list" :key="item.id" @click="goTopicsDeclarationList(item)">
                <a href="javascript:void(0);" class="card d-block">
                  <div class="card-body text-center">
                    <i class="mdi mdi-ballot-outline"></i>
                    <h3>
                      <span>{{ item.projectName }}</span>
                    </h3>
                    <p class="text-muted mb-0" style="text-align:left;">申报截止：{{ item.declareEndTime | getMMDDHHmmTime }} <span :style="{color:getColor(item.declareEndTime)}">({{item.declareEndTime|isTimeOut}})</span></p>
                    <p class="text-muted mb-0" style="text-align:left;">初审截止：{{ item.trialEndTime | getMMDDHHmmTime }}</p>
                    <div class="btn-wrap" style="margin-top: 10px;">
                      <el-button size="mini" type="warning" @click.stop="edit(item)" v-if="item.createId==userinfo.id">修改</el-button>
                      <el-button size="mini" type="danger" v-if="item.mark" @click.stop="del(item.id)">删除</el-button>
                    </div>
                  </div>
                </a>
              </div>

              <div class="col-md-4 col-xl-3" @click="toAdd" v-if="isAllow">
                <a href="javascript:void(0);" class="card d-block">
                  <div class="card-body text-center">
                    <i class="dripicons-plus"></i>
                    <h3 class="text-nowrap"><span>发布课题申报通知</span></h3>
                  </div>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- end wrapper-->
    </div>

  </div>
</template>

<script>
import { getProjectIdByQualification } from "@/api/after/expertScore";
import { getEduProjectLsit, delProject } from '@/api/after/projectApplication';
import { getLastestProjectToReview } from '@/api/after/expertScore.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
  name: 'topicsDeclaration',
  components: {
    Breadcrumb
  },
  data() {
    return {
      list: [],
      userinfo: JSON.parse(sessionStorage.getItem('userInfo')),
    };
  },
  computed: {
    isAllow() {
      //判断当前用户是否具有发布项目权限
      if (this.userinfo) {
        console.log(this.userinfo.roleList);
        if (this.userinfo.roleList) {
          let typeList = this.userinfo.roleList.map(item => {
            return item.type;
          });
          return typeList.includes(9);
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // 通过时间判断颜色
    getColor(time) {
      return time => {
        if (time) {
          if (new Date(time).getTime() > Date.now()) {
            return 'green'
          } else {
            return 'red'
          }
        }
      }
    }
  },
  filters: {
    isTimeOut(val) {
      if (new Date(val).getTime() > Date.now()) {
        return '进行中'
      } else {
        return '已截止'
      }
    },
    getMMDDHHmmTime(val) {
      return val.slice(5, -3)
    }
  },
  async created() {
    await this.getData();
    // let userinfo = JSON.parse(sessionStorage.getItem('userInfo'));
    if (this.userinfo) {
      if (this.userinfo.roleId.includes(3)) {
        const res = await getLastestProjectToReview();
        if (res.code == 200) {
          this.$confirm('您当前有待评分的任务，是否自动跳转到专家评分页面？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              let projectData = this.list.find(item => {
                return item.id == res.data;
              });
              sessionStorage.setItem('projectData', JSON.stringify(projectData));
              this.$message.success('已帮您跳转到最新待评项目中！');
              this.$router.push('/backstage/expertScoreList');
            })
            .catch(() => {

            });
        } else {
          this.$message.warning(res.data);
        }
      }
    }

  },
  methods: {
    async getData() {
      const res = await getEduProjectLsit();
      if (res.code == 200) {
        this.list = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    toAdd() {
      this.$router.push('/backstage/newProject');
    },
    // 跳转到该项目的课题列表页面
    goTopicsDeclarationList(data) {
      sessionStorage.setItem('projectData', JSON.stringify(data));
      this.getProjectIdByQualification(data.id)
      // let query={ id: data.id, declareEndTime: data.declareEndTime, limit: data.memberNumberLimit }
      // this.$router.push({ path: '/backstage/topicsList', query: query});

    },
    // 通过项目id来查看当前登录人是否有初评复评终评资格
    async getProjectIdByQualification(id) {
      let res = await getProjectIdByQualification(id);
      if (res.code == 200) {
        let data = res.data;
        let menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]')
        if (menuList[0].path == 'topicsDeclaration') {
          menuList[0].children = menuList[0].children.map(item => {
            if (item.path == 'expertScoreList') {
              item.isShow = (data.internState || data.reviewState || data.finalState) ? 1 : 2
            }
            return item
          })
        }
        sessionStorage.setItem('menuList', JSON.stringify(menuList))
      } else {
        this.$message.error(res.data);
      }
      if (this.userinfo.roleId === '2') {
        this.$router.push('/backstage/schoolTopicReviewList');
      } else if (this.userinfo.roleId === '5') {
        this.$router.push('/backstage/areaReviewList');
      } else {
        this.$router.push('/backstage/topicsList');
      }
    },
    edit(data) {
      let projectData = encodeURIComponent(JSON.stringify(data));
      this.$router.push('/backstage/newProject?projectData=' + projectData);
    },
    // 删除项目
    del(projectId) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await delProject(projectId);
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getData();
          } else {
            this.$message.error(res.data);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
h3 span {
  font-size: 16px;
  overflow: auto;
  white-space: wrap;
  text-overflow: unset;
}
.card-body h3 {
  height: 52px;
}
.row-subProject a {
  height: 295px;
}
.card-body.text-center {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
